import { appPath } from '@fs/zion-config'
import { getSessionStorageItem } from './sessionStorage'
import cleanupCenterUser from './sessionCleanup'

/**
 * The one shared read of the session-stored kiosk config.
 *
 * `config` (written by getStation for multi-app kiosks; its `navMenu` is the
 * /selectexperience lineup) wins over `kioskSettings` (written on kiosk code
 * entry) when it carries a lineup. `navMenu` presence on the result is the
 * multi-app signal.
 */
// The multi-app kiosk's own menu - the one level above an experience there.
export const KIOSK_MENU_PATH = '/selectexperience'

export function getKioskConfig() {
  const kioskSettings = getSessionStorageItem('kioskSettings') || {}
  const stationConfig = getSessionStorageItem('config')
  return stationConfig?.navMenu ? stationConfig : kioskSettings
}

/**
 * Where undocking lands. A config missing keyCodeUndockRedirect falls back
 * to the app root - never the `${appPath}undefined` dead URL (appPath itself
 * is undefined under jest).
 */
export function getUndockUrl(conf = getKioskConfig()) {
  return `${appPath || ''}${conf?.keyCodeUndockRedirect || '/'}`
}

/**
 * Undocks the kiosk: clears the center session, then hard-navigates to the
 * config's undock destination. `resetContainerSession: true` is the
 * idle-timeout variant (matches cleanupCenterUser's flag).
 */
export function undockKiosk({ resetContainerSession = false, conf = getKioskConfig() } = {}) {
  cleanupCenterUser(resetContainerSession)
  window.location = getUndockUrl(conf)
}
